import { render } from "./CloudflareMediaDemo.vue?vue&type=template&id=41aa0dbd&scoped=true"
import script from "./CloudflareMediaDemo.vue?vue&type=script&lang=js"
export * from "./CloudflareMediaDemo.vue?vue&type=script&lang=js"

import "./CloudflareMediaDemo.vue?vue&type=style&index=0&id=41aa0dbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aa0dbd"]])

export default __exports__